import {useEffect, useState, useRef,useForm} from 'react'
import {withRouter} from 'react-router-dom';
import {Breadcrumb, Col, Container, Row} from 'react-bootstrap'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight, faCheck, faClose, faPlus} from "@fortawesome/free-solid-svg-icons";
import Api from "../../../../services/Api";
import HelperGeneral from "../../../../helpers/HelperGeneral";
import UserInfo from "../../../auth/UserInfo";
import {Button, Empty, Form, Input, Spin} from 'antd'
import {setGlobalSpinner} from "../../../../services/redux/actions/GeneralAction";
import moment from "moment";
import order_1 from "../../../../assets/order_1.json";
import order_100001 from "../../../../assets/order_100001.json";
import order_100000001 from "../../../../assets/order_100000001.json";
import Lottie from "react-lottie";
import {trans} from "../../../../helpers/HelperGlobal";
import _ from "lodash";
import Search from "../../../partials/Search";


const GiveGiftOrder = (props) => {
    const formRef = useRef(null);
    const [orderDetail, setOrderDetail] = useState({})
    const [loading, setLoading] = useState(null)
    const [orders, setOrders] = useState([])
    const [approvedProducts, setApprovedProduct] = useState('')
    const [productCreateShow, setProductCreateShow] = useState(false)
    const [operation, setOperation] = useState(false)
    const [form] = Form.useForm();


    useEffect(() => {
        getOrders();
    }, [])

    const getOrders = () => {
        const userId = props?.info?.customerId;
        const deliveryCode = props?.info?.deliveryCode; //öncesinde ordenNumber kullanılıyordu. sonradan sorgulanan değer teslimat koduna çevrildi. bir önceki variable adı orderNumber olarak geçebilir.
        setLoading(true)
        Api.getOrders(userId, 1).then((e) => {
            setLoading(false)
            const orders = _.filter(e?.data?.result, ['deliveryCode', deliveryCode])
            setOrders(orders)
        }).catch(e => {
            HelperGeneral.alert(e)
            setLoading(false)
        })
    }
    const approvedProduct = (productId, operation) => {
        let newData = approvedProducts.split(',');
        if (operation) {
            if (newData.indexOf(productId) < 0) {
                newData.push(productId)
            }
        } else {
            const index = newData.indexOf(productId);
            if (index > -1) {
                newData.splice(index, 1);
            }
        }
        setApprovedProduct(newData.join())
    }

    const onFinishOrder = (values) => {
        const orderId = orderDetail?.id;
        const orderNumber = orderDetail?.orderNumber;
        const userId = props?.info?.customerId;
        if (orderId) {
            let data = [];
            Object.keys(values).map((obj, key) => {
                const event = {
                    price: 0,
                    totalDiscount: 0,
                    taxAmount: 0
                };
                Object.assign(values[obj], event);
                data.push(values[obj])
                return obj;
            }, {})
            const orderSendData = {
                orderId: orderId,
                details: data
            }
            setLoading(true)
            let checkData = {
                orderId: orderId,
                customerId: userId,
                details: data
            };
            Api.orderBasketDetailCheck(checkData).then(res => {
                if (res?.data?.result?.result) {
                    Api.orderDetailUpdate(orderSendData).then(r => {
                        const orderCommitData = {
                            orderId: orderId,
                            orderNumber: orderNumber,
                            isPaymentApproved: true,
                            OrderStatus: 100001
                        };
                        setLoading(true)
                        Api.orderCommit(orderCommitData).then(r => {
                            props.sendStep(3)
                            setLoading(false)
                        }).catch((e) => {
                            setLoading(false)
                            HelperGeneral.alert(e)
                        })
                    }).catch((e) => {
                        setLoading(false)
                        HelperGeneral.alert(e)
                    })
                } else {
                    setLoading(false)
                    return HelperGeneral.alert(res?.data?.result?.errorMessage, 'error')
                }
            }).catch((e) => {
                setLoading(false)
                HelperGeneral.alert(e?.data?.message)
            })
        } else {
            HelperGeneral.alert("Sipariş bulunamadı. Tekrar deneyiniz.", "error")
        }
    }


    return (
        <div className={"row "}>
            <div className={'col-12'}>
                <Spin spinning={loading}>
                    <div
                        className={(Object.keys(orderDetail).length !== 0 ? '' : ' product-history') + ' orders'}>
                        {
                            Object.keys(orderDetail).length !== 0 ? (
                                <>
                                    <h4 className={'mb-4 pl-0'}>
                                        <FontAwesomeIcon
                                            icon={faArrowLeft}
                                            style={{cursor: 'pointer'}}
                                            onClick={() => {
                                                setOrderDetail({})
                                                props.sendStep(1)
                                            }}/> Sipariş Detayı</h4>

                                    <div className={' shadow-none'}>
                                        <Form
                                            layout={'vertical'}
                                            ref={formRef}
                                            form={form}
                                            initialValues={{layout: ''}}
                                            onFinish={(e) => {
                                                return onFinishOrder(e)
                                            }}
                                        >
                                            <div className={'row'}>
                                                <div
                                                    className={"col-12 mb-3 d-flex justify-content-end align-items-center"}>
                                                    <Button type={productCreateShow ? "danger" : "primary"}
                                                            htmlType="button" className="login-form-button"
                                                            onClick={() => setProductCreateShow(!productCreateShow)}>
                                                        {!productCreateShow ? (<><FontAwesomeIcon icon={faPlus}/> Ürün
                                                            Ekle</>) : (<><FontAwesomeIcon icon={faClose}/> Ürün
                                                            Eklemeyi Kapat</>)}
                                                    </Button>
                                                </div>
                                                {
                                                    productCreateShow && (
                                                        <div className={"col-lg-6 col-12 mb-3 mx-auto"}>
                                                            <Search addOrder={true} addOrderItem={(item) => {
                                                                if (orderDetail?.orderProducts.findIndex(v => v.product?.productId === item?.product?.productId) > -1) {
                                                                    HelperGeneral.alert("Ürün bulunmaktadır", "error")
                                                                } else {
                                                                    orderDetail?.orderProducts.push(item)
                                                                    setOrderDetail(orderDetail)
                                                                    setOperation(!operation)
                                                                }
                                                            }}/>
                                                        </div>
                                                    )
                                                }
                                                <div className={'col-12  '}>

                                                    {
                                                        orderDetail?.orderProducts.map((v2, i2) => (
                                                            <div className={"row p-3 pl-0 gift-basket-list"}
                                                                 key={i2}
                                                                 style={{cursor: "pointer"}}>
                                                                <div
                                                                    className={"col-12 col-md-2 d-flex justify-content-start align-items-center"}>
                                                                    <img
                                                                        onClick={() => window.location.href = "/product/" + v2?.product?.productId}
                                                                        src={v2?.product?.imageUrl}
                                                                        className={'img-thumbnail'}
                                                                        style={{
                                                                            width: 100,
                                                                            maxHeight: 90,
                                                                            objectFit: 'cover'
                                                                        }}/>
                                                                </div>
                                                                <div
                                                                    className={"col-12 col-md-7 d-flex justify-content-start align-items-center"}>
                                                                    <div className={"row"}>
                                                                        <div className={"col-12"}
                                                                             onClick={() => window.location.href = "/product/" + v2?.product?.productId}>
                                                                            {v2?.product?.productName}
                                                                        </div>
                                                                        <div className={"col-12"}>
                                                                            <b>{v2?.quantity} Adet</b>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={"col-12 col-md-3 d-flex justify-content-center align-items-center text-center"}>


                                                                    <Form.Item name={[i2, "productId"]}
                                                                               initialValue={v2?.product?.productId}>
                                                                        <Input type={"hidden"}/>
                                                                    </Form.Item>
                                                                    <Form.Item name={[i2, "quantity"]}
                                                                               initialValue={v2?.quantity}>
                                                                        <Input type={"hidden"}/>
                                                                    </Form.Item>
                                                                    <div className={"row"}>
                                                                        <div className={"col-12 "}>
                                                                            <Form.Item name={[i2, "giftCode"]}
                                                                                       className={" m-0 p-0 mb-2"}
                                                                                       rules={[
                                                                                           {
                                                                                               required: true,
                                                                                               message: 'Zorunlu alan'
                                                                                           },
                                                                                       ]}>
                                                                                <Input placeholder="Kodu Gir"
                                                                                       className={approvedProducts.includes(v2?.product?.productId) ? '' : 'd-none'}/>
                                                                            </Form.Item>
                                                                        </div>
                                                                        <div className={"col-12 m-0 p-0"}>
                                                                            <Form.Item className={" m-0 p-0"}>
                                                                                <Button
                                                                                    className={'btn text-white btn-danger m-2 mt-0 pb-2 ' + (approvedProducts.includes(v2?.product?.productId) ? '' : 'd-none')}
                                                                                    style={{lineHeight: 1.1}}
                                                                                    onClick={() => {
                                                                                        approvedProduct(v2?.product?.productId, false)
                                                                                        form.setFieldsValue({
                                                                                            [i2]:{
                                                                                                giftCode:''
                                                                                            }
                                                                                        });
                                                                                    }}>
                                                                                    <FontAwesomeIcon icon={faClose} className={"me-2"}/>   Vazgeç
                                                                                </Button>
                                                                            </Form.Item>
                                                                        </div>
                                                                    </div>
                                                                    {!approvedProducts.includes(v2?.product?.productId) && (
                                                                        <Form.Item className={"d-flex justify-content-center align-items-center"}>
                                                                            <Button
                                                                                className={'btn text-white btn-primary m-2 mt-0 pb-2'}
                                                                                style={{lineHeight: 1.1}}
                                                                                onClick={() => approvedProduct(v2?.product?.productId, true)}>
                                                                                <FontAwesomeIcon icon={faCheck} className={"me-2"}/>  Onayla
                                                                            </Button>
                                                                            <Button
                                                                                className={'btn text-white btn-danger m-2 mt-0 pb-2'}
                                                                                style={{lineHeight: 1.1}}
                                                                                onClick={() => {
                                                                                    orderDetail?.orderProducts.splice(orderDetail?.orderProducts.findIndex(v => v.product?.productId === v2?.product?.productId), 1);
                                                                                    setOrderDetail(orderDetail)
                                                                                    setOperation(!operation)
                                                                                }}>
                                                                                 <FontAwesomeIcon icon={faClose} className={"me-2"}/>  Sil
                                                                            </Button>
                                                                        </Form.Item>

                                                                    )}

                                                                </div>
                                                            </div>
                                                        ))
                                                    }

                                                </div>

                                                {
                                                    orderDetail?.orderProducts.length > 0 && (
                                                        <div className={"col-12"}>
                                                            <Form.Item className={"text-center mt-3"}>
                                                                <Button type="primary"
                                                                        style={{height: 56}}
                                                                        htmlType="submit"
                                                                    //onClick={() => orderCommit(orderDetail?.id, orderDetail?.orderNumber)}
                                                                        className="login-form-button">Onayla ve Devam
                                                                    et</Button>
                                                            </Form.Item>
                                                        </div>
                                                    )
                                                }

                                            </div>
                                        </Form>
                                    </div>
                                </>
                            ) : (
                                <>

                                    {
                                        orders.map((v, i) => (
                                            <div
                                                key={i}
                                                className={'row mb-3  order-item'}
                                                onClick={() => {
                                                    setOrderDetail(v)
                                                    props.sendStep(2)
                                                }}>
                                                <div
                                                    className={'col-12 col-md-4 d-flex justify-content-center  justify-content-md--start  align-items-center mb-4 m-md-0'}>
                                                    {
                                                        v.orderProducts.slice(0, 2).map((v2, i2) => (
                                                            <img
                                                                key={i2}
                                                                src={v2?.product?.imageUrl}
                                                                className={'img-thumbnail '}
                                                                style={{
                                                                    width: 70,
                                                                    height: 70,
                                                                    borderRadius: '50%',
                                                                    marginLeft: i2 === 1 ? -20 : 0
                                                                }}/>
                                                        ))
                                                    }
                                                    {
                                                        v.orderProducts.length > 2 && (
                                                            <div
                                                                className={"d-flex justify-content-center align-items-center shadow"}
                                                                style={{
                                                                    width: 70,
                                                                    height: 70,
                                                                    borderRadius: '50%',
                                                                    background: '#eaeaea',
                                                                    marginLeft: -20,
                                                                    fontSize: 18
                                                                }}>
                                                                {v.orderProducts.length - 2} +
                                                            </div>
                                                        )
                                                    }

                                                </div>
                                                <div
                                                    className={'col-12 col-md-3 d-flex justify-content-center align-items-center mb-4 m-md-0'}>
                                                    <div
                                                        className={'row h-100'}>
                                                        <div
                                                            className={'col-12 text-center'}>
                                                            <span>Sipariş Tarihi</span>
                                                        </div>
                                                        <div
                                                            className={'col-12 text-center'}>{moment(v.orderDate).format('DD.MM.YYYY HH:mm:ss')}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className={'col-12 col-md-3 d-flex justify-content-center align-items-center mb-4 m-md-0'}>
                                                    <div className={'row h-100'}>
                                                        <div
                                                            className={'col-12 text-center'}>
                                                            <span>Sipariş Numarası</span>
                                                        </div>
                                                        <div
                                                            className={'col-12 text-center'}>{v.orderNumber}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className={'col-12 col-md-1 d-flex justify-content-center align-items-center'}>
                                                    <FontAwesomeIcon
                                                        icon={faArrowRight}/>
                                                </div>
                                            </div>
                                        ))
                                    }

                                    {
                                        !loading && orders.length < 1 && (
                                            <Empty
                                                description={'Sipariş bulunamadı'}
                                            />
                                        )
                                    }


                                </>
                            )

                        }

                    </div>
                </Spin>
            </div>
        </div>
    );
}

export default withRouter(GiveGiftOrder);
